<p-card
  header="Dane osób powiązanych z organizacją"
  tabindex="0"
  class="custom-card"
>
  <app-admin-panel-user-organization-related-persons-table
    [userDetails]="userDetails()"
    [organizationId]="organizationId()"
  ></app-admin-panel-user-organization-related-persons-table>
</p-card>
